// extracted by mini-css-extract-plugin
export default {"pageContainer":"src_pageContainer__404+I","textNotFound":"src_textNotFound__cPB9q","spinner":"src_spinner__vOxOC","logo":"src_logo__ZFImf","logoDiv":"src_logoDiv__Z5Ypx"};